import {
  HOLDED_GET_CONTACTS_LIST,
  HOLDED_GET_CONTACTS_LIST_SUCCESS,
  HOLDED_GET_CONTACTS_LIST_ERROR,
  HOLDED_GET_CONTACT_INFO,
  HOLDED_GET_CONTACT_INFO_SUCCESS,
  HOLDED_GET_CONTACT_INFO_ERROR,
  HOLDED_ADD_CONTACT_INFO,
  HOLDED_ADD_CONTACT_INFO_SUCCESS,
  HOLDED_ADD_CONTACT_INFO_ERROR,
  HOLDED_UPDATE_CONTACT_INFO,
  HOLDED_UPDATE_CONTACT_INFO_SUCCESS,
  HOLDED_UPDATE_CONTACT_INFO_ERROR,
  HOLDED_ADD_DOCUMENT_ITEM,
  HOLDED_ADD_DOCUMENT_ITEM_SUCCESS,
  HOLDED_ADD_DOCUMENT_ITEM_ERROR,
  HOLDED_CLEAR_DATA,
} from "../actions";

//* GET CONTACTS LIST from Holded // ---------------------------------------------------------------------------------------------
export const getContactsListHolded = () => {
  return {
    type: HOLDED_GET_CONTACTS_LIST,
  };
};

export const getContactsListHoldedSuccess = (items) => {
  console.log(items);
  return { type: HOLDED_GET_CONTACTS_LIST_SUCCESS, payload: items };
};

export const getContactsListHoldedError = (error) => ({
  type: HOLDED_GET_CONTACTS_LIST_ERROR,
  payload: error,
});

//* GET CONTACT INFO from Holded // ---------------------------------------------------------------------------------------------
export const getContactInfoHolded = (payload) => {
  console.log(payload);

  return {
    type: HOLDED_GET_CONTACT_INFO,
    payload: payload,
  };
};

export const getContactInfoHoldedSuccess = (items) => {
  console.log(items);
  return { type: HOLDED_GET_CONTACT_INFO_SUCCESS, payload: items };
};

export const getContactInfoHoldedError = (error) => ({
  type: HOLDED_GET_CONTACT_INFO_ERROR,
  payload: error,
});

//* ADD CONTACT INFO to Holded // ---------------------------------------------------------------------------------------------
export const addContactInfoHolded = (payload) => {
  console.log(payload);

  return {
    type: HOLDED_ADD_CONTACT_INFO,
    payload: payload,
  };
};

export const addContactInfoHoldedSuccess = (items) => {
  console.log(items);
  return { type: HOLDED_ADD_CONTACT_INFO_SUCCESS, payload: items };
};

export const addContactInfoHoldedError = (error) => ({
  type: HOLDED_ADD_CONTACT_INFO_ERROR,
  payload: error,
});

//* ADD CONTACT INFO to Holded // ---------------------------------------------------------------------------------------------
export const updateContactInfoHolded = (payload) => {
  console.log(payload);

  return {
    type: HOLDED_UPDATE_CONTACT_INFO,
    payload: payload,
  };
};

export const updateContactInfoHoldedSuccess = (items) => {
  console.log(items);
  return { type: HOLDED_UPDATE_CONTACT_INFO_SUCCESS, payload: items };
};

export const updateContactInfoHoldedError = (error) => ({
  type: HOLDED_UPDATE_CONTACT_INFO_ERROR,
  payload: error,
});

//* ADD DOCUMENT ITEM to Holded // ---------------------------------------------------------------------------------------------
export const addDocumentItemHolded = (payload) => {
  console.log(payload);

  return {
    type: HOLDED_ADD_DOCUMENT_ITEM,
    payload: payload,
  };
};

export const addDocumentItemHoldedSuccess = (items) => {
  console.log(items);
  return { type: HOLDED_ADD_DOCUMENT_ITEM_SUCCESS, payload: items };
};

export const addDocumentItemHoldedError = (error) => ({
  type: HOLDED_ADD_DOCUMENT_ITEM_ERROR,
  payload: error,
});

//* CLEAR DATA in Redux// ---------------------------------------------------------------------------------------------
// clearing redux state at logout
export const clearDataHolded = (history) => {
  return {
    type: HOLDED_CLEAR_DATA,
    payload: { history },
  };
};
